// MWC inherits table constants from cccc
import ccccConstants from './cccc';

export default ccccConstants;
